module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_List_of_Plates"
    }
  }, [_c('i', [_vm._v("List of Plates")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Acknowledgements"
    }
  }, [_c('i', [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Part01"
    }
  }, [_c('b', [_vm._v("Part One")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("Chapter 1:      The Origins of the First World War Revisited")]), _vm._v(" "), _c('i', [_vm._v("by Gary Sheffield")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter02"
    }
  }, [_vm._v("Chapter 2:      British Readiness for War")]), _vm._v(" "), _c('i', [_vm._v("by John Bourne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3:      The Shock of War: How Britain Entered the First World War")]), _vm._v(" "), _c('i', [_vm._v("by Catriona Pennell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4:      The National Response to the Outbreak of War, 1914")]), _vm._v(" "), _c('i', [_vm._v("by Edward M. Spiers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:      War Readiness in Britain: the Royal Navy, August 1914–January 1915")]), _vm._v(" "), _c('i', [_vm._v("by Dominic Tweddle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6:      True Grit: Officers of the British Expeditionary Force and the Great Retreat, 1914")]), _vm._v(" "), _c('i', [_vm._v("by Spencer Jones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7:      The Raising of the New Armies: Some Further Reflections")]), _vm._v(" "), _c('i', [_vm._v("by Peter Simkins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8:      First Clash of Arms in the West: British and German Soldiers in Action, 1914")]), _vm._v(" "), _c('i', [_vm._v("by Matthew Richardson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9:      The Green Howards and Corporal Tom Riordan at the First Battle of Ypres")]), _vm._v(" "), _c('i', [_vm._v("by Roger Chapman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10:    Britons in Berlin: Ruhleben – the Internment of British Civilians")]), _vm._v(" "), _c('i', [_vm._v("by Peter Liddle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11:    The Torment of Captivity: Germans, Austrians and Turks Interned on the Isle of Man")]), _vm._v(" "), _c('i', [_vm._v("by Matthew Richardson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12:    From Cricket Whites to Khaki – Sport and the Great War")]), _vm._v(" "), _c('i', [_vm._v("by Clive Harris")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13:    Infantry Weapons of the Great War")]), _vm._v(" "), _c('i', [_vm._v("by John Whitchurch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14:    ‘Kettledrums of Death’: Some Field Guns and Howitzers of the Great War")]), _vm._v(" "), _c('i', [_vm._v("by Philip Magrath")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15:    Silent Soldiers: Animals in the Great War")]), _vm._v(" "), _c('i', [_vm._v("by Paul Skelton-Stroud")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16:    New Horizons – A War in the Air, 1914")]), _vm._v(" "), _c('i', [_vm._v("by Nick Forder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17:    The Mobilization and Experience of Nurses in the First World War")]), _vm._v(" "), _c('i', [_vm._v("by Alison S. Fell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18:    Tracing Your Family’s History in the Great War")]), _vm._v(" "), _c('i', [_vm._v("by Chris Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19:    The Liddle Collection of First World War Archival Materials in the University of Leeds")]), _vm._v(" "), _c('i', [_vm._v("by Peter Liddle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20:    Lawnswood Cemetery in Leeds and the First World War")]), _vm._v(" "), _c('i', [_vm._v("by Andrea Hetherington")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes_Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes on Contributors")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0